import {SHType} from "../common/SHType";

export enum FileStatusTypeId {
    AwaitingIngest = 1,
    Ingesting = 2,
    Processing = 3,
    Ready = 4,
    Deleted = 5,
    Error = 6
}

class _FileStatusType extends SHType<FileStatusTypeId> {
    constructor() {
        super(
            "FileStatusType",
            [
                [FileStatusTypeId.AwaitingIngest, "awaiting_ingest"],
                [FileStatusTypeId.Ingesting, "ingesting"],
                [FileStatusTypeId.Processing, "processing"],
                [FileStatusTypeId.Ready, "ready"],
                [FileStatusTypeId.Deleted, "deleted"],
                [FileStatusTypeId.Error, "error"]
            ]
        );
    }

}

//added suffix "Obj" to avoid conflict with legacy FileStatusType enum
export const FileStatusTypeObj = new _FileStatusType();
